// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout_wrapper__oM37w","breadcrumbsWrapper":"Layout_breadcrumbsWrapper__cwrFL","comparatorBar":"Layout_comparatorBar__xG_Dd"};